import React, { useEffect, useRef, useState } from "react";
import StatisticsCards from "./components/StatisticsCards";
import StatisticsCharts from "./components/StatisticsCharts";
import OrdersOverview from "./components/OrdersOverview";
import InfoCard from "./components/InfoCard";
import { useDispatch, useSelector } from "react-redux";
import { getUserType } from "../../dashboard/services/getUserProfile";
import { getknowlageBaseInfo } from "../services/knowlageBaseInfo";
import { setUser } from "../../dashboard/store/userSlice";
import KeywordCloud from "./components/charts/KeywordCloud";
import {
  messagePerDayChart,
  topUsersChart,
  wordCloudChart,
} from "./components/services/chartServices";
import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function Home() {
  const { t } = useTranslation(["user"]);

  const [wallet, setWallet] = useState("");
  const [users, setUsers] = useState("");
  const [usedTokens, setUsedTokens] = useState("");
  const [planTokens, setPlanTokens] = useState("");
  const dispatch = useDispatch();
  const [chats, setChats] = useState("");
  const [supportChats, setSupportChats] = useState("");
  const [remainingTokens, setRemainingTokens] = useState("");
  const [planName, setPlanName] = useState("");
  const [todayAvgTokens, setTodayAvgTokens] = useState("");
  const [endDay, setEndDay] = useState("");
  const [startDay, setStartDay] = useState("");
  const [messagePerDaychartDate, setMessagePerDayChartDate] = useState([]);
  const [messagePerDaychartLoading, setMessagePerDaychartLoading] = useState(false);
  const [messagePerHourChart, setMessagePerHourChart] = useState([]);
  const [loadingDay, setLoadingDay] = useState(false);
  const [loadingHour, setLoadingHour] = useState(false);
  const [topUsersData, setTopUsersData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [wordCloudData, setWordCloudData] = useState([]);
  const [wordCloudlLoading, setWordCloudLoading] = useState(false);
  const [botInfoLoading, setBotInfoLoading] = useState(false);
  const now = new Date();
  const past30Days = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
  const isLoadingAllCharts = loadingDay || loadingHour || loading;
  const accessToken = useSelector((state) => state.auth.accessToken);
  const wordCloudRef = useRef(null);
  const [wcHeight, setWcHeight] = useState(0);

  useEffect(() => {
    const update = () => {
      if (wordCloudRef.current) {
        setWcHeight(wordCloudRef.current.offsetHeight);
      }
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  useEffect(() => {
    const storedStart = localStorage.getItem("startDate");
    const storedEnd = localStorage.getItem("endDate");

    if (!storedStart || !storedEnd) {
      const now = new Date();
      const past30Days = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
      past30Days.setUTCHours(0, 0, 0, 0);
      localStorage.setItem("startDate", past30Days.toISOString());
      localStorage.setItem("endDate", now.toISOString());
    }
  }, []);

  const fetchMessagePerDay = async ({ startDate, endDate, accessToken, withHour }) => {
    try {
      if (withHour) setLoadingHour(true);
      else setLoadingDay(true);

      const response = await messagePerDayChart({ startDate, endDate, accessToken, withHour });

      if (response?.data && Array.isArray(response.data)) {
        if (withHour) setMessagePerHourChart(response.data);
        else setMessagePerDayChartDate(response.data);
      } else {
        if (withHour) setMessagePerHourChart([]);
        else setMessagePerDayChartDate([]);
      }
    } catch (error) {
      console.error("خطا در دریافت داده:", error);
      if (withHour) setMessagePerHourChart([]);
      else setMessagePerDayChartDate([]);
    } finally {
      setTimeout(() => {
        if (withHour) setLoadingHour(false);
        else setLoadingDay(false);
      }, 150);
    }
  };

  const fetchtopUsers = async ({ startDate, endDate, accessToken }) => {
    try {
      setLoading(true);
      const response = await topUsersChart({ startDate, endDate, accessToken });
      if (response?.data && Array.isArray(response.data)) {
        setTopUsersData(response.data);
      } else {
        setTopUsersData([]);
      }
    } catch (error) {
      console.error("خطا در دریافت داده:", error);
      setTopUsersData([]);
    } finally {
      setTimeout(() => setLoading(false), 150);
    }
  };

  const fetchWordCloud = async ({ startDate, endDate, accessToken }) => {
    try {
      setWordCloudLoading(true);
      const response = await wordCloudChart({ startDate, endDate, accessToken });
      if (response?.data) {
        const wordRes = Object.entries(response.data).map(([key, value]) => ({
          text: key,
          value: value,
        }));
        setWordCloudData(wordRes);
      } else {
        setWordCloudData([]);
      }
    } catch (error) {
      console.error("خطا در دریافت داده:", error);
      setWordCloudData([]);
    } finally {
      setTimeout(() => setWordCloudLoading(false), 150);
    }
  };

  useEffect(() => {
    const botInfo = async () => {
      try {
        setBotInfoLoading(true);
        const res = await getknowlageBaseInfo(accessToken);
        if (res?.ok) {
          setWallet(res?.data?.wallet);
          setUsers(res?.data?.users);
          setUsedTokens(res?.data?.usedTokens);
          setChats(res?.data?.chats);
          setSupportChats(res?.data?.supportChats);
          setRemainingTokens(res?.data?.subscription?.remainingTokens);
          setPlanName(res?.data?.plan?.name);
          setTodayAvgTokens(res?.data?.todayAvgTokens);
          setPlanTokens(res?.data?.plan?.tokens);
          setEndDay(res?.data?.subscription?.endDate);
          setStartDay(res?.data?.subscription?.startDate);
        }
      } catch (error) {
        console.error("خطا در دریافت اطلاعات بات:", error);
      } finally {
        setBotInfoLoading(false);
      }
    };
    botInfo();

    past30Days.setUTCHours(0, 0, 0, 0);
    fetchMessagePerDay({ accessToken, startDate: past30Days, endDate: now.toISOString(), withHour: false });
    fetchMessagePerDay({ accessToken, startDate: past30Days, endDate: now.toISOString(), withHour: true });
    fetchtopUsers({ accessToken, startDate: past30Days, endDate: now.toISOString() });
    fetchWordCloud({ accessToken, startDate: past30Days, endDate: now.toISOString() });
  }, [accessToken]);

  const handleApplyFilter = async ({ startDate, endDate }) => {
    if (!accessToken) return;
    localStorage.setItem("startDate", startDate);
    localStorage.setItem("endDate", endDate);
    await Promise.allSettled([
      fetchWordCloud({ startDate, endDate, accessToken }),
      fetchMessagePerDay({ startDate, endDate, accessToken, withHour: false }),
      fetchMessagePerDay({ startDate, endDate, accessToken, withHour: true }),
      fetchtopUsers({ startDate, endDate, accessToken }),
    ]);
  };

  /* ============ Section wrapper for consistent styling ============ */
  const Section = ({ title, subtitle, children }) => (
    <section className="relative">
      {(title || subtitle) && (
        <header className="mb-4 flex items-center gap-3">
          <span className="shrink-0 flex h-7 w-7 items-center justify-center rounded-lg bg-gradient-to-br from-amber-300/30 to-teal-400/20 border border-amber-300/40">
            <Sparkles size={14} className="text-amber-300" />
          </span>
          <div>
            {title && (
              <h3 className="text-sm font-bold text-slate-800 dark:!text-amber-100">
                {title}
              </h3>
            )}
            {subtitle && (
              <p className="text-[11px] text-slate-500 dark:!text-slate-400 mt-0.5">
                {subtitle}
              </p>
            )}
          </div>
          <div className="flex-1 h-[1px] bg-gradient-to-l from-transparent via-teal-400/30 to-transparent" />
        </header>
      )}
      {children}
    </section>
  );

  return (
    <div
      className="
        relative mt-1 space-y-8 sm:space-y-10
        px-1 sm:px-2
        text-slate-800 dark:!text-slate-100
      "
    >
      {/* Decorative background glows */}
      <div className="pointer-events-none absolute -top-10 -right-20 h-56 w-56 rounded-full bg-amber-300/10 blur-3xl" />
      <div className="pointer-events-none absolute top-1/3 -left-24 h-64 w-64 rounded-full bg-teal-400/10 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 right-1/4 h-56 w-56 rounded-full bg-teal-500/5 blur-3xl" />

      <div className="relative space-y-8 sm:space-y-10">

        {/* ============ KPI Cards ============ */}
        <Section>
          <div
            className="
              rounded-2xl
              bg-gradient-to-tr from-teal-100 via-cyan-50 to-emerald-50
dark:!bg-gradient-to-tr dark:!from-[#0B2E2F] dark:!via-slate-900 dark:!to-[#0F3B3C]
              backdrop-blur-xl
              border border-teal-500/10 dark:!border-teal-400/10
              shadow-[0_10px_40px_-20px_rgba(15,118,110,0.35)]
              dark:!shadow-[0_10px_40px_-20px_rgba(0,0,0,0.8)]
              p-3 sm:p-4
            "
          >
            <StatisticsCards
              planName={planName}
              wallet={wallet}
              remainingTokens={remainingTokens}
              planTokens={planTokens}
              endDay={endDay}
              startDay={startDay}
              botInfoLoading={botInfoLoading}
            />
          </div>
        </Section>

        {/* ============ Info Card ============ */}
        <Section>

          <InfoCard
            users={users}
            chats={chats}
            todayAvgTokens={todayAvgTokens}
            botInfoLoading={botInfoLoading}
          />

        </Section>

        {/* ============ Orders + Word Cloud ============ */}
        <Section
          title={t("dashboard.sections.keywordAnalysis.title")}
          subtitle={t("dashboard.sections.keywordAnalysis.subtitle")}
        >
          <div className="grid grid-cols-1 xl:grid-cols-3 xl:gap-x-6 gap-y-6 items-stretch">

            {/* ================= OrdersOverview (Filter + Emotion) ================= */}
            {/* ⚠️ overflow-hidden حذف شد تا پاپ‌آپ فیلتر بتونه بیرون بزنه */}
            <div
              className="
        relative
        rounded-2xl
        bg-white/60 dark:bg-slate-900/60
        backdrop-blur-xl
        border border-teal-500/10 dark:border-teal-400/10
        shadow-[0_10px_40px_-20px_rgba(15,118,110,0.35)]
        dark:shadow-[0_10px_40px_-20px_rgba(0,0,0,0.8)]
        p-3 sm:p-4
        z-30
      "
            >
              <OrdersOverview onApplyFilter={handleApplyFilter} height={wcHeight} />
            </div>

            {/* ================= KeywordCloud ================= */}
            <div
              className="
        relative w-full col-span-1 xl:col-span-2
        rounded-2xl
        bg-white/60 dark:bg-slate-900/60
        backdrop-blur-xl
        border border-teal-500/10 dark:border-teal-400/10
        shadow-[0_10px_40px_-20px_rgba(15,118,110,0.35)]
        dark:shadow-[0_10px_40px_-20px_rgba(0,0,0,0.8)]
        p-3 sm:p-4
        z-10
      "
            >
              <KeywordCloud wordCloudData={wordCloudData} ref={wordCloudRef} />
            </div>

          </div>
        </Section>

        {/* ============ Charts ============ */}
        <Section
          title={t("dashboard.sections.analyticalCharts.title")}
          subtitle={t("dashboard.sections.analyticalCharts.subtitle")}
        >
          <div
            className="
              rounded-2xl
              bg-white/60 dark:!bg-slate-900/60
              backdrop-blur-xl
              border border-teal-500/10 dark:!border-teal-400/10
              shadow-[0_10px_40px_-20px_rgba(15,118,110,0.35)]
              dark:!shadow-[0_10px_40px_-20px_rgba(0,0,0,0.8)]
              p-3 sm:p-4
            "
          >
            <StatisticsCharts
              loadingDay={loadingDay}
              loadingHour={loadingHour}
              messagePerDaychartDate={messagePerDaychartDate}
              messagePerHourChart={messagePerHourChart}
              topUsersData={topUsersData}
              loading={loading}
              isLoadingAllCharts={isLoadingAllCharts}
            />
          </div>
        </Section>

      </div>
    </div>
  );
}